var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: { id: "personal_info_mobile_modal", "no-close-on-backdrop": true },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "close-modal-btn mr-7",
                    attrs: { id: "personal_info_mobile_modal_close_btn" },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-x",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "button",
                {
                  staticClass: "bb-btn btn-success",
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("personalInfoMobileModal.saveBtn")) +
                      " "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("h2", [_vm._v(_vm._s(_vm.$t("personalInfoMobileModal.title")))]),
      _c(
        "div",
        { staticClass: "bb-form-group" },
        [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("personalInfoMobileModal.genderInput.label"))),
          ]),
          _c("BBSelect", {
            attrs: { options: _vm.genderOptions },
            model: {
              value: _vm.selectedGender,
              callback: function ($$v) {
                _vm.selectedGender = $$v
              },
              expression: "selectedGender",
            },
          }),
        ],
        1
      ),
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("personalInfoMobileModal.birthdayInput.label"))),
      ]),
      _c("BBSelect", {
        staticClass: "mb-8 birthday-input",
        attrs: {
          placeholder: _vm.$t(
            "personalInfoMobileModal.birthdayInput.monthPlaceholder"
          ),
          options: _vm.monthOptions,
        },
        model: {
          value: _vm.birthday.month,
          callback: function ($$v) {
            _vm.$set(_vm.birthday, "month", $$v)
          },
          expression: "birthday.month",
        },
      }),
      _c(
        "div",
        { staticClass: "birthday-inputs-group" },
        [
          _c("BBSelect", {
            staticClass: "birthday-input",
            attrs: {
              placeholder: _vm.$t(
                "personalInfoMobileModal.birthdayInput.dayPlaceholder"
              ),
              options: _vm.dayOptions,
            },
            model: {
              value: _vm.birthday.day,
              callback: function ($$v) {
                _vm.$set(_vm.birthday, "day", $$v)
              },
              expression: "birthday.day",
            },
          }),
          _c("BBSelect", {
            staticClass: "birthday-input",
            attrs: {
              placeholder: _vm.$t(
                "personalInfoMobileModal.birthdayInput.yearPlaceholder"
              ),
              options: _vm.yearOptions,
            },
            model: {
              value: _vm.birthday.year,
              callback: function ($$v) {
                _vm.$set(_vm.birthday, "year", $$v)
              },
              expression: "birthday.year",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }